import { render, staticRenderFns } from "./FooterNewsletter.vue?vue&type=template&id=1e4fbff6&"
import script from "./FooterNewsletter.vue?vue&type=script&lang=js&"
export * from "./FooterNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports